import React from 'react';
export function IssuerHeader() {
  return <div className="min-w-0 text-left" data-id="element-1358">
      <img src="https://cdn.magicpatterns.com/uploads/3HmLapdTMRvTJbmSkdh1g8/Bmedhospital.png" alt="BMED Medical Centre" className="mb-2 h-14 w-14 object-contain" data-id="element-1359" />
      <p className="billing-issuer-name font-bold uppercase tracking-wide text-pink-600" data-id="element-1360">
        BMED MEDICAL CENTRE
      </p>
      <p className="mt-0.5 italic text-slate-600" data-id="element-1361">Caring Healing Leading</p>
      <address className="billing-issuer-contact mt-3 space-y-0.5 not-italic text-slate-700" data-id="element-1362">
        <p data-id="element-1363">Plot No. 1884/10, Along Avic Road, Lilayi Estate</p>
        <p data-id="element-1364">Kafue, Lusaka - Zambia</p>
        <p data-id="element-1365">Contact: +260975202011</p>
        <p data-id="element-1366">Email: bmedhospital@gmail.com</p>
        <p data-id="element-1367">TPIN:2000869447</p>
      </address>
    </div>;
}